import { FC, SVGAttributes } from 'react';
import { observer } from 'mobx-react';
import Parser from 'html-react-parser';

import classes from './Button.module.scss';

import { StringMap } from '@/utils/constant';
import ArrowSVG from '@/assets/svg/arrow.svg';

type ButtonProps = JSX.IntrinsicElements['div'] & {
    text?: string;
    colorScheme?: string;
    onClick?: VoidFunction;
    onMouseLeave?: VoidFunction;
    onMouseEnter?: VoidFunction;
    link?: string;
    svg?: FC<SVGAttributes<SVGElement>>;
    disabled?: boolean;
    type?: any;
    submit?: boolean;
    newTab?: boolean;
    arrow?: boolean;
};

const colorSchemes: StringMap = {
    primary: classes.primary,
    secondary: classes.secondary,
    white: classes.white,
};

export default observer<FC<ButtonProps>>(function Button({
    text,
    colorScheme = 'primary',
    onClick,
    link,
    svg,
    type,
    disabled = false,
    className = '',
    onMouseLeave,
    onMouseEnter,
    submit = false,
    newTab = true,
    arrow = false,
}) {
    if (link) {
        if (!svg) {
            return (
                <a
                    href={link}
                    target={newTab ? '_blank' : '_self'}
                    rel="noreferrer noopener"
                    className={`${classes.btn} ${disabled ? classes.disabled : ''} ${
                        colorSchemes[colorScheme]
                    } ${className && classes[className]}`}
                    onMouseLeave={onMouseLeave}
                    onMouseEnter={onMouseEnter}
                    onClick={onClick}
                >
                    <span>{text}</span>
                </a>
            );
        } else {
            return (
                <a
                    href={link}
                    target={newTab ? '_blank' : '_self'}
                    rel="noreferrer noopener"
                    className={`${classes.btnIcon} ${disabled ? classes.disabled : ''} ${
                        colorSchemes[colorScheme]
                    } ${className && classes[className]}`}
                    onClick={onClick}
                    aria-label={text}
                    onMouseLeave={onMouseLeave}
                    onMouseEnter={onMouseEnter}
                >
                    <div className={classes.btnWrapper}>
                        <div className={classes.icon}>{svg({})}</div>
                        {text && <span>{Parser(text)}</span>}
                        {arrow && <ArrowSVG className={classes.arrow} />}
                    </div>
                </a>
            );
        }
    }
    if (svg) {
        return (
            <button
                className={`${classes.btnIcon} ${disabled ? classes.disabled : ''} ${
                    colorSchemes[colorScheme]
                } ${className && classes[className]}`}
                onClick={onClick}
                aria-label={text}
                onMouseLeave={onMouseLeave}
                onMouseEnter={onMouseEnter}
            >
                <div className={classes.btnWrapper}>
                    <div className={classes.icon}>{svg({})}</div>
                    {text && <span>{Parser(text)}</span>}
                    {arrow && <ArrowSVG className={classes.arrow} />}
                </div>
            </button>
        );
    }
    if (submit) {
        return (
            <input
                type={'submit'}
                className={`${classes.btn} ${disabled ? classes.disabled : ''} ${
                    colorSchemes[colorScheme]
                } ${className && classes[className]}`}
                aria-label={text}
                onClick={onClick}
                onMouseLeave={onMouseLeave}
                onMouseEnter={onMouseEnter}
                placeholder={text}
                value={text}
            />
        );
    }
    return (
        <button
            type={type}
            className={`${classes.btn} ${disabled ? classes.disabled : ''} ${
                colorSchemes[colorScheme]
            } ${className && classes[className]}`}
            aria-label={text}
            onClick={onClick}
            onMouseLeave={onMouseLeave}
            onMouseEnter={onMouseEnter}
        >
            {text && <span>{Parser(text)}</span>}
            {arrow && <ArrowSVG className={classes.arrow} />}
        </button>
    );
});
